"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as i } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: h, size: c = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const l = n(), a = h !== null && h !== void 0 ? h : l ? t.colors.inverse : t.colors.neutralHigh, { skinName: r } = i();
    return r.match(/^o2-new/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ o("path", {
            fill: a,
            d: "M14.935 2c2.124 0 3.901 1.623 4.309 3.773h2.284V22H2.48V5.773h8.145C11.033 3.623 12.81 2 14.935 2m2.93 4.715c0-1.768-1.313-3.208-2.93-3.208s-2.931 1.44-2.931 3.208c0 1.193 1.608 4.208 2.93 6.353 1.323-2.15 2.931-5.16 2.931-6.353M3.943 10.246v10.247h6.424a4 4 0 0 1-.924-2.387Q9.438 18.05 9.44 18v-1.28c0-.947-.558-1.213-1.937-1.633-1.149-.348-2.574-.783-2.818-2.406q-.009-.057-.01-.116v-1.13c0-.527-.3-.976-.731-1.189m9.894 10.247h6.232V7.285h-.787c-.441 2.498-3.377 7.044-3.733 7.594a.73.73 0 0 1-.61.334.73.73 0 0 1-.61-.334c-.36-.55-3.291-5.096-3.732-7.594H3.943v1.377c1.252.26 2.2 1.406 2.2 2.773v1.067c.112.575.637.793 1.776 1.14 1.262.382 2.988.909 2.988 3.078v1.13c0 1.817 1.519 2.643 2.93 2.643m3.025-14.155c0-1.096-.868-1.985-1.927-1.985-1.065 0-1.928.893-1.928 1.985s.863 1.986 1.928 1.986 1.927-.89 1.927-1.986m-2.757 0c0-.473.37-.855.83-.855s.83.382.83.855c0 .474-.37.855-.83.855a.84.84 0 0 1-.83-.855"
        })
    })) : r.match(/^o2/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ o("path", {
            fill: a,
            d: "M14.935 2c2.124 0 3.901 1.623 4.309 3.773h2.284V22H2.48V5.773h8.145C11.033 3.623 12.81 2 14.935 2m2.93 4.715c0-1.768-1.313-3.208-2.93-3.208s-2.931 1.44-2.931 3.208c0 1.193 1.608 4.208 2.93 6.353 1.323-2.15 2.931-5.16 2.931-6.353M3.943 10.246v10.247h6.424a4 4 0 0 1-.924-2.387Q9.438 18.05 9.44 18v-1.28c0-.947-.558-1.213-1.937-1.633-1.149-.348-2.574-.783-2.818-2.406q-.009-.057-.01-.116v-1.13c0-.527-.3-.976-.731-1.189m9.894 10.247h6.232V7.285h-.787c-.441 2.498-3.377 7.044-3.733 7.594a.73.73 0 0 1-.61.334.73.73 0 0 1-.61-.334c-.36-.55-3.291-5.096-3.732-7.594H3.943v1.377c1.252.26 2.2 1.406 2.2 2.773v1.067c.112.575.637.793 1.776 1.14 1.262.382 2.988.909 2.988 3.078v1.13c0 1.817 1.519 2.643 2.93 2.643m3.025-14.155c0-1.096-.868-1.985-1.927-1.985-1.065 0-1.928.893-1.928 1.985s.863 1.986 1.928 1.986 1.927-.89 1.927-1.986m-2.757 0c0-.473.37-.855.83-.855s.83.382.83.855c0 .474-.37.855-.83.855a.84.84 0 0 1-.83-.855"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ o("path", {
            fill: a,
            d: "M21.636 21.692a.61.61 0 0 0 .182-.619l-2.291-8.02a.6.6 0 0 0-.337-.386.6.6 0 0 0-.512.011l-2.695 1.345-.168-.053c1.165-1.9 2.174-4.056 2.18-5.813.01-3.745-2.216-5.986-5.959-5.997h-.028C8.28 2.16 6.05 4.387 6.04 8.12c-.005 1.687.964 3.83 2.107 5.749l-.322.092-2.244-1.269a.6.6 0 0 0-.871.342l-2.527 8.025a.61.61 0 0 0 .171.63.61.61 0 0 0 .644.104l4.23-1.837 4.429 1.815q.041.016.09.028l.111.025a.58.58 0 0 0 .364-.025l4.605-1.846 4.168 1.837a.604.604 0 0 0 .642-.098M7.244 8.118c.011-3.07 1.7-4.76 4.762-4.76h.025c3.076.01 4.765 1.71 4.756 4.788-.008 2.84-3.395 7.429-4.795 9.064-1.521-1.764-4.757-6.378-4.748-9.092m13.061 12.048-2.938-1.294-.667-3.869 1.863-.93zm-16.577-.009 1.908-6.056 1.468.83-.457 3.957zm7.687-1.793-.014 1.998-3.544-1.454.437-3.83.516-.15c1.02 1.557 2.05 2.843 2.605 3.436m1.204-.047c.476-.53 1.496-1.773 2.521-3.3l.364.115.65 3.793-3.549 1.42zM10.92 7.79c0-.75.35-1.098 1.095-1.098.748 0 1.098.35 1.098 1.098s-.35 1.096-1.098 1.096-1.095-.348-1.095-1.096m1.098 2.303c1.42 0 2.302-.883 2.302-2.303s-.882-2.302-2.302-2.302-2.303.882-2.303 2.302.883 2.303 2.303 2.303"
        })
    }));
}, d = s;
export { d as default };
